/**
 * External Imports
 */
import { FC, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes, useParams } from 'react-router-dom';

/**
 * Internal Imports
 */
import Login from '../login/Login';
import PatientCensus from './PatientCensus';
import PatientIssues from './PatientIssues';
import PatientFeedback from './PatientFeedback';
import PatientStoplight from './PatientStoplight';
import PatientProfile from './PatientProfile';

import {
  setStoplightSearchQuery,
  setTaskSearchQuery,
  setUserSection,
  clearUserSection
} from '../../redux/actions';
import { useDebounceValue } from '../../utils/debouncers';

const Patient: FC<{}> = () => {
  // TODO: What was this for?
  // let match = useMatch();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState<string>('');

  const dbSearchTerm = useDebounceValue(searchTerm, 250);

  const { '*': view } = useParams();

  /**
   * In order to identify whether the user is in Employee or Patient section.
   * store variable: userSection
   */
  useEffect(() => {
    dispatch(setUserSection('patient'));
    return () => {
      dispatch(clearUserSection());
    };
  }, []);

  useEffect(() => {
    if (view?.includes('issues')) dispatch(setTaskSearchQuery(searchTerm));
    if (view?.includes('feedback')) dispatch(setTaskSearchQuery(searchTerm));
    if (view?.includes('stoplight'))
      dispatch(setStoplightSearchQuery(searchTerm));
    return () => {
      dispatch(setTaskSearchQuery(''));
      dispatch(setStoplightSearchQuery(''));
    };
  }, [dbSearchTerm]);

  return (
    <div>
      <Routes>
        {/* <Route path="*" element={<Navigate to="census" replace />} /> */}
        <Route
          path="census"
          element={
            <PatientCensus
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          }
        />
        <Route
          path="issues"
          element={
            <PatientIssues
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          }
        />
        <Route
          path="feedback"
          element={
            <PatientFeedback
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          }
        />
        <Route
          path="stoplight"
          element={
            <PatientStoplight
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          }
        />
        <Route path="profile" element={<PatientProfile />} />
        <Route path="*" element={<Login />} />
      </Routes>
    </div>
  );
};

export default Patient;
